import * as types from "../actions/ActionTypes";
import validation from "../utilities/SettingsValidation";
import ProductFilter from "../utilities/OrganizationProductFilter";

export const getInitialState = () => (
    {
        settings: null,
        logo: null,
        ssoSettings: null,
        products: []
    });

const settingsReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_ORGANIZATION_BY_ID_SUCCEEDED: {
        const products = ProductFilter.filterProductsJS(action.organization.products);
        return Object.assign({}, state, { products: products });
    }
    case types.GET_ORGANIZATION_SETTINGS_BY_ID_SUCCEEDED:
        return Object.assign({}, state, { settings: action.settings });
    case types.GET_ORGANIZATION_LOGO_SUCCEEDED:
        return Object.assign({}, state, { logo: action.result });
    case types.GET_ORGANIZATION_SSO_SETTINGS_BY_ID_SUCCEEDED:
        return Object.assign({}, state, { ssoSettings: action.settings });
    case types.SET_ORGANIZATION_LOGO: {
        const logo = action.result;
        logo.isValid = validation.validateImage(action.result);
        return Object.assign({}, state, { logo: logo });
    }
    case types.SAVE_ORGANIZATION_LOGO_SUCCEEDED: {
        const logo = Object.assign({}, state.logo);
        logo.isNew = false;
        return Object.assign({}, state, { logo: logo });
    }
    case types.SETTINGS_SET_WEB_TIMEOUT: {
        const newSettings = state.settings.createCopy();

        if (!state.settings.settingsLocks.webTimeout)
            newSettings.webTimeout = action.value;
        return Object.assign({}, state, { settings: newSettings });
    }
    case types.SETTINGS_SET_ACCOUNT_LOCKOUT_INTERVAL: {
        const newSettings = state.settings.createCopy();
        if (!state.settings.settingsLocks.interval)
            newSettings.accountLockoutPolicy.interval = action.value;

        return Object.assign({}, state, { settings: newSettings });
    }
    case types.SETTINGS_SET_ACCOUNT_LOCKOUT_THRESHOLD: {
        const newSettings = state.settings.createCopy();
        if (!state.settings.settingsLocks.threshold)
            newSettings.accountLockoutPolicy.threshold = action.value;
        return Object.assign({}, state, { settings: newSettings });
    }
    case types.SETTINGS_SET_PASSWORD_MAXIMUM_AGE: {
        const settings = state.settings.createCopy();
        if (!state.settings.settingsLocks.maximumAge)
            settings.passwordPolicy.maximumAge = action.value;
        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_PASSWORD_MINIMUM_LENGTH: {
        const settings = state.settings.createCopy();
        if (!state.settings.settingsLocks.minimumLength)
            settings.passwordPolicy.minimumLength = action.value;
        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_ALLOW_PASSWORD_ALPHA_CHAR: {
        const settings = state.settings.createCopy();

        const allow = action.value;

        if (!settings.settingsLocks.alphabeticalCharacters) {

            settings.passwordPolicy.alphabeticalCharacters.required = allow;

            if (!settings.settingsLocks.uppercaseCharacters) {
                settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.required = false;
                settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number = 0;
            }

            if (!settings.settingsLocks.lowercaseCharacters) {
                settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.required = false;
                settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number = 0;
            }
            setPasswordAlphabeticalCharactersNumber(settings, allow ? 1 : 0);
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_PASSWORD_ALPHA_CHAR_NUMBER: {
        const settings = state.settings.createCopy();
        if (!settings.settingsLocks.alphabeticalCharacters) {
            const alphabeticalCharactersPasswordPolicy = settings.passwordPolicy.alphabeticalCharacters;

            alphabeticalCharactersPasswordPolicy.number = action.value;
            if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                setMinimumLengthNumber(settings);
            }
        }
        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_PASSWORD_NUM_CHAR_NUMBER: {
        const settings = state.settings.createCopy();

        if(!settings.settingsLocks.numericCharacters) {

            const numericCharactersPasswordPolicy = settings.passwordPolicy.numericCharacters;

            numericCharactersPasswordPolicy.number = action.value;
            if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                setMinimumLengthNumber(settings);
            }
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_ALLOW_PASSWORD_UPPERCASE: {
        const settings = state.settings.createCopy();
        const allow = action.value;

        if (!settings.settingsLocks.uppercaseCharacters) {
            settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.required = allow;
            setPasswordUppercaseCharactersNumber(settings, allow ? 1 : 0);
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_PASSWORD_UPPERCASE_NUMBER: {
        const settings = state.settings.createCopy();

        if (!settings.settingsLocks.uppercaseCharacters) {
            const uppercaseCharactersPasswordPolicy = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters;

            uppercaseCharactersPasswordPolicy.number = action.value;
            if (!validation.validateAlphabeticalCharactersSumOfFieldsRule(settings)) {
                setAlphabeticalCharactersMinimumPasswordNumber(settings);
                if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                    setMinimumLengthNumber(settings);
                }
            }
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_ALLOW_PASSWORD_LOWERCASE: {
        const settings = state.settings.createCopy();
        const allow = action.value;

        if (!settings.settingsLocks.lowercaseCharacters) {
            settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.required = allow;
            setPasswordLowercaseCharactersNumber(settings, allow ? 1 : 0);
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_PASSWORD_LOWERCASE_CHAR_NUMBER: {
        const settings = state.settings.createCopy();

        if (!settings.settingsLocks.lowercaseCharacters) {
            const lowercaseCharactersPasswordPolicy = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters;

            lowercaseCharactersPasswordPolicy.number = action.value;
            if (!validation.validateAlphabeticalCharactersSumOfFieldsRule(settings)) {
                setAlphabeticalCharactersMinimumPasswordNumber(settings);
                if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                    setMinimumLengthNumber(settings);
                }
            }
        }
        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_ALLOW_PASSWORD_NUMERICS: {
        const settings = state.settings.createCopy();
        const allow = action.value;

        if (!settings.settingsLocks.numericCharacters) {
            settings.passwordPolicy.numericCharacters.required = allow;
            setPasswordNumericCharactersNumber(settings, allow ? 1 : 0);
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_ALLOW_PASSWORD_PUNCT_OTHER_CHAR: {
        const settings = state.settings.createCopy();
        const allow = action.value;

        if (!settings.settingsLocks.punctuationOrOtherCharacters) {
            settings.passwordPolicy.punctuationOrOtherCharacters.required = allow;
            setPasswordPunctuationOrOtherCharactersNumber(settings, allow ? 1 : 0);
        }

        return Object.assign({}, state, { settings: settings });
    }
    case types.SETTINGS_SET_PASSWORD_PUNCT_OTHER_CHAR_NUMBER: {
        let settings = state.settings.createCopy();

        if (!settings.settingsLocks.punctuationOrOtherCharacters) {
            const punctuationOrOtherCharactersPasswordPolicy = settings.passwordPolicy.punctuationOrOtherCharacters;

            punctuationOrOtherCharactersPasswordPolicy.number = action.value;
            if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                settings = setMinimumLengthNumber(settings);
            }
        }
        return Object.assign({}, state, { settings: settings });
    }
    default:
        return state;
    }
};

const setPasswordPunctuationOrOtherCharactersNumber= (settings, number) => {
    if(!settings.settingsLocks.punctuationOrOtherCharacters) {
        const punctuationOrOtherCharactersPasswordPolicy = settings.passwordPolicy.punctuationOrOtherCharacters;

        punctuationOrOtherCharactersPasswordPolicy.number = number;
        if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
            setMinimumLengthNumber(settings);
        }
    }
};

const setPasswordAlphabeticalCharactersNumber = (settings, number) => {
    if (!settings.settingsLocks.alphabeticalCharacters) {
        const alphabeticalCharactersPasswordPolicy = settings.passwordPolicy.alphabeticalCharacters;

        alphabeticalCharactersPasswordPolicy.number = number;
        if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
            setMinimumLengthNumber(settings);
        }
    }
};

const setPasswordUppercaseCharactersNumber = (settings, number) => {
    if (!settings.settingsLocks.uppercaseCharacters) {
        const uppercaseCharactersPasswordPolicy = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters;

        uppercaseCharactersPasswordPolicy.number = number;
        if (!validation.validateAlphabeticalCharactersSumOfFieldsRule(settings)) {
            setAlphabeticalCharactersMinimumPasswordNumber(settings);
            if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                setMinimumLengthNumber(settings);
            }
        }
    }
};

const setAlphabeticalCharactersMinimumPasswordNumber = (settings) => {
    if (!settings.settingsLocks.alphabeticalCharacters) {
        settings.passwordPolicy.alphabeticalCharacters.number = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number +
            settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number;
    }
};

const setMinimumLengthNumber = (settings) => {
    if (!settings.settingsLocks.minimumLength) {
        settings.passwordPolicy.minimumLength = settings.passwordPolicy.alphabeticalCharacters.number +
            settings.passwordPolicy.numericCharacters.number +
            settings.passwordPolicy.punctuationOrOtherCharacters.number;
    }
    return settings;
};

const setPasswordNumericCharactersNumber = (settings, number) => {
    if (!settings.settingsLocks.numericCharacters) {

        const numericCharactersPasswordPolicy = settings.passwordPolicy.numericCharacters;

        numericCharactersPasswordPolicy.number = number;
        if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
            setMinimumLengthNumber(settings);
        }
    }
};

const setPasswordLowercaseCharactersNumber = (settings, number) => {
    if(!settings.settingsLocks.lowercaseCharacters) {
        const lowercaseCharactersPasswordPolicy = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters;

        lowercaseCharactersPasswordPolicy.number = number;
        if (!validation.validateAlphabeticalCharactersSumOfFieldsRule(settings)) {
            setAlphabeticalCharactersMinimumPasswordNumber(settings);
            if (!validation.validateMinimumLengthSumOfFieldsRule(settings)) {
                setMinimumLengthNumber(settings);
            }
        }
    }
};

export default settingsReducer;
